<template>
  <!-- SEO 위계용 태그 : 실제로 노출되지 않음 -->
  <h1 class="blind">4060만을 위한 모임 커뮤니티, 오이에서 함께해요.</h1>

  <!-- pc용 QR 모달 : .blind 조절 -->
  <div class="bl_modal_dimmed" v-show="downloadModalShown">
    <div class="bl_modal">
      <section class="bl_modal_cont">
        <QRCode :value="useGetStoreLink()" />
        <h2>
          스마트폰 카메라로 QR코드를 비추면<br />다운로드 페이지로 연결돼요
        </h2>
      </section>
      <button class="bl_modal_btn" @click="downloadModalShown = false">
        닫기
      </button>
    </div>
  </div>

  <!-- 탑 바 -->
  <section class="bl_topBar_wrapper">
    <div class="bl_topBar">
      <a
        ><img src="/images/index/logo_textVer.svg" v-auto-title alt="오이로고"
      /></a>
      <div class="bl_topBar_nav">
        <NuxtLink to="/app/dining" :target="linkTarget" class="el_plainBtn_s"
          >오이 다이닝</NuxtLink
        >
        <NuxtLink
          to="/gathering/list"
          :target="linkTarget"
          class="el_plainBtn_s"
          >취미 모임</NuxtLink
        >
        <NuxtLink
          to="/gathering/feed/list"
          :target="linkTarget"
          class="el_plainBtn_s"
          >소통 공간</NuxtLink
        >
      </div>
      <!-- Mobile상태일 때 다운로드 : 스토어 연결 -->
      <a
        target="_blank"
        class="bl_topBar_btn rc_onlyMobile"
        :href="useGetStoreLink()"
        @click="onAppDownloadClick(false)"
        >앱 다운로드</a
      >
      <!-- PC상태일 때 다운로드 : QR모달 오픈 -->
      <a class="bl_topBar_btn rc_onlyPC" @click="onAppDownloadClick(true)"
        >앱 다운로드</a
      >
    </div>
  </section>

  <section class="ly_pageContainer">
    <!-- 빌보드 -->
    <section class="bl_billboard">
      <section class="bl_billboard_heroWrapper">
        <div class="bl_billboard_hero">
          <p>취미 소셜 커뮤니티</p>
          <h2>일상에 설렘을 더하다</h2>
          <!-- 확인필요 -->
          <a
            class="bl_billboard_btn rc_onlyMobile"
            target="_blank"
            :href="useGetStoreLink()"
            @click="onAppDownloadClick(false)"
            >앱 다운로드</a
          >
          <a
            class="bl_billboard_btn rc_onlyPC"
            @click.stop="onAppDownloadClick(true)"
            >앱 다운로드</a
          >
        </div>
        <NuxtLink
          to="/app/dining"
          :target="linkTarget"
          class="bl_billboard_hero __article"
        >
          <div>
            <h2>매주 수요일<br />낯선 사람들과<br />저녁자리</h2>
            <!-- 확인필요 -->
            <span class="bl_billboard_ctaText">
              자세히 보기
              <i class="ic_base __arrow-tail-right __size20 __color50"></i>
            </span>
          </div>
        </NuxtLink>
      </section>
      <div class="bl_billboard_menu rc_onlyPC">
        <NuxtLink to="/gathering/list" :target="linkTarget">
          <h3>오이의 모임들을 소개할게요</h3>
          <p>취미모임</p>
        </NuxtLink>
        <NuxtLink to="/gathering/feed/list" :target="linkTarget">
          <h3>유저들의 활동을 구경해보세요</h3>
          <p>소통 공간</p>
        </NuxtLink>
        <NuxtLink to="/app/dining" :target="linkTarget">
          <h3>신청하고 오시면 돼요</h3>
          <p>오이 다이닝</p>
        </NuxtLink>
      </div>
    </section>
    <!-- 에너지 가득한 모임 -->
    <section class="bl_article">
      <div class="bl_article_header">
        <h2>에너지 가득한 모임</h2>
        <NuxtLink
          class="bl_article_btn el_plainBtn_s __arrow __fontLarge"
          to="/gathering/list?keyword=에너지"
          >모두보기</NuxtLink
        >
      </div>
      <div class="bl_cardList">
        <NuxtLink
          class="bl_card"
          v-for="(gathering, index) in gatheringListEnergy"
          :key="index"
          :to="`/gathering/${gathering.id}`"
        >
          <CustomImage :src="gathering.image" alt="모임 이미지"></CustomImage>
          <!-- <img :src="gathering.image" v-auto-title alt="모임 이미지" /> -->
          <div class="bl_card_desc">
            <h4>{{ gathering.interest }}</h4>
            <h3>{{ gathering.title }}</h3>
            <p>{{ gathering.description }}</p>
            <i class="bl_card_ps"
              ><strong>{{ gathering.memberInfo.count }}</strong
              >/{{ gathering.memberInfo.capacity }}명</i
            >
          </div>
        </NuxtLink>
      </div>
    </section>
    <!-- 소통이 활발한 모임 -->
    <section class="bl_article">
      <div class="bl_article_header">
        <h2>소통이 활발한 모임</h2>
        <NuxtLink
          class="bl_article_btn el_plainBtn_s __arrow __fontLarge"
          to="/gathering/list?keyword=소통"
          >모두보기</NuxtLink
        >
      </div>
      <div class="bl_cardList __2col">
        <NuxtLink
          class="bl_card __row"
          v-for="(gathering, index) in gatheringListCommunication"
          :key="index"
          :to="`/gathering/${gathering.id}`"
        >
          <CustomImage :src="gathering.image" alt="모임 이미지"></CustomImage>
          <!-- <img :src="gathering.image" v-auto-title alt="모임 이미지" /> -->
          <div class="bl_card_desc">
            <h4>{{ gathering.interest }}</h4>
            <h3>{{ gathering.title }}</h3>
            <p>{{ gathering.description }}</p>
            <i class="bl_card_ps"
              ><strong>{{ gathering.memberInfo.count }}</strong
              >/{{ gathering.memberInfo.capacity }}명</i
            >
          </div>
        </NuxtLink>
      </div>
      <NuxtLink
        to="/gathering/list?keyword=소통"
        class="bl_article_btn_mobile el_lineBtn __m __arrow hp_mt32"
        >모두보기</NuxtLink
      >
    </section>
    <!-- 오이 다이닝 -->
    <section class="bl_article_pointWrapper __dining">
      <!-- 화면 전체 너비 배경 -->
      <div class="bl_article">
        <!-- 컨텐츠 -->
        <div class="bl_article_pointInner __center">
          <div class="bl_article_header __center">
            <h2>찾는 모임이 없으신가요?</h2>
          </div>
          <section class="un_dining">
            <article class="un_dining_billboard">
              <h3>
                낯선 사람과<br class="onlyMobile_br" />
                설레는 저녁 한 끼
              </h3>
              <p>
                신청만 하면 이번주 수요일에<br class="onlyMobile_br" />
                새로운 사람들과 만날 수 있어요.<br />
                모든 준비를 오이가 해드릴게요.<br class="onlyMobile_br" />
                지금 바로 신청해보세요.
              </p>
              <img
                class="rc_onlyPC"
                alt="다이닝 더미 프로필 묶은 이미지"
                src="/images/home/img_diningPart_profileList.png"
              />
              <img
                class="rc_onlyMobile"
                alt="다이닝 더미 프로필 묶은 이미지"
                src="/images/home/img_diningPart_profileStack.png"
              />
              <NuxtLink to="/app/dining" :target="linkTarget">
                <button>자세히 보기</button>
              </NuxtLink>
            </article>
            <article class="un_dining_below">
              <div class="un_dining_overview">
                <h4>OE Dining</h4>
                <p>
                  관심사가 비슷한 낯선 사람들과<br />새로운 설렘을 만나보세요
                </p>
              </div>
              <ul class="un_dining_steps">
                <li class="un_dining_step">
                  <span>1</span>
                  <dl>
                    <dt>신청</dt>
                    <dd>
                      클릭 한번으로 간단하게 신청해보세요.<br />
                      오이가 함께할 분들과 모이는 장소를 모두 준비해드릴게요.
                    </dd>
                  </dl>
                </li>
                <li class="un_dining_step">
                  <span>2</span>
                  <dl>
                    <dt>초대장</dt>
                    <dd>
                      초대장에 화요일 저녁 7시에 장소가 안내되어 있어요.<br />
                      함께하는 멤버의 힌트도 알 수 있어요.
                    </dd>
                  </dl>
                </li>
                <li class="un_dining_step">
                  <span>3</span>
                  <dl>
                    <dt>식당 방문</dt>
                    <dd>
                      수요일 저녁 7시에 초대장에 안내된 장소에 방문해서<br />
                      “오이 다이닝으로 예약했어요”라고 말씀해 주세요.
                    </dd>
                  </dl>
                </li>
                <li class="un_dining_step">
                  <span>4</span>
                  <dl>
                    <dt>다이닝</dt>
                    <dd>매칭된 분들과 흥미로운 식사를 즐겨보세요.</dd>
                  </dl>
                </li>
              </ul>
            </article>
          </section>
        </div>
      </div>
    </section>
    <!-- 전국 모임 랭킹 -->
    <section class="bl_article_pointWrapper __bgNone">
      <!-- 화면 전체 너비 배경 -->
      <div class="bl_article">
        <!-- 컨텐츠 -->
        <div class="bl_article_pointInner">
          <div class="bl_article_header">
            <h2>전국 모임 랭킹</h2>
          </div>
          <!-- 스크롤 일어나는 박스 -->
          <div class="bl_cardList_carousel">
            <!-- 움직이는 요소 -->
            <div class="bl_cardList __rankingV" ref="rankingCarousel">
              <NuxtLink
                class="bl_card"
                v-for="(gathering, index) in gatheringListRanking"
                :key="index"
                :to="`/gathering/${gathering.id}`"
              >
                <figure>
                  <CustomImage
                    :src="gathering.image"
                    alt="모임 이미지"
                  ></CustomImage>
                  <!-- <img :src="gathering.image" v-auto-title alt="모임 이미지" /> -->
                  <span>{{ index + 1 }}</span>
                </figure>
                <div class="bl_card_desc">
                  <h4>{{ gathering.interest }}</h4>
                  <h3>{{ gathering.title }}</h3>
                  <p>
                    {{ gathering.description }}
                  </p>
                  <i class="bl_card_ps">
                    <strong>{{ gathering.memberInfo.count }}</strong>
                    /
                    {{ gathering.memberInfo.capacity }}명
                  </i>
                </div>
              </NuxtLink>
            </div>
            <!--왼쪽 버튼은 .blind로 조절 -->
            <button
              v-show="rankingCarouselPrevButtonShown"
              class="--left"
              @click="addRankingCarouselIndex(-3)"
            ></button>
            <button
              v-show="rankingCarouselNextButtonShown"
              class="--right"
              @click="addRankingCarouselIndex(+3)"
            ></button>
          </div>
          <!-- /스크롤 일어나는 박스 -->
        </div>
        <!-- /컨텐츠 -->
      </div>
      <!-- /화면 전체 너비 배경 -->
    </section>
    <!-- 띠 배너 (only PC) -->
    <!-- <NuxtLink to="/introduceOE" class="bl_stripBanner rc_onlyPC">
      <img src="/images/home/il_letter.svg" v-auto-title alt="배너 아이콘" />
      <dl class="bl_stripBanner_desc">
        <dt>오이에 대해서 궁금하세요?</dt>
        <dd>앱 소개</dd>
      </dl>
    </NuxtLink> -->
    <!-- 모임의 순간들 -->
    <section class="bl_article_pointWrapper __bgNone">
      <!-- 화면 전체 너비 배경 -->
      <div class="bl_article">
        <!-- 컨텐츠 -->
        <div class="bl_article_pointInner __pad0">
          <div class="bl_article_header">
            <h2>모임의 순간들</h2>
            <NuxtLink
              class="bl_article_btn el_plainBtn_s __arrow __fontLarge"
              :to="`/gathering/feed/list`"
              >모두보기</NuxtLink
            >
          </div>
          <!-- 스크롤 일어나는 박스 -->
          <div class="bl_cardList_carousel">
            <!-- 움직이는 요소 -->
            <div class="bl_cardList __feedV" ref="feedCarousel">
              <NuxtLink
                class="bl_card"
                v-for="(feed, index) in gatheringFeedList"
                :key="feed.id"
                :to="`/gathering/feed/${feed.id}`"
              >
                <figure
                  v-if="!isString(feed.image)"
                  class="bl_card_viedoImgWrapper"
                >
                  <CustomImage
                    :src="feed.image.thumbnailUrl"
                    alt="피드 이미지"
                  ></CustomImage>
                </figure>
                <CustomImage
                  v-else
                  :src="feed.image"
                  alt="피드 이미지"
                ></CustomImage>
                <!-- <img :src="feed.image" v-auto-title alt="모임 이미지" /> -->
                <div class="bl_card_desc">
                  <figure class="bl_card_profile">
                    <CustomProfileImage
                      :src="feed.author.image"
                      v-auto-title
                      alt="유저 프로필"
                    ></CustomProfileImage>
                    <!-- <img :src="feed.author.getImage" v-auto-title alt="유저 프로필" /> -->
                    <figcaption>{{ feed.author.nickname }}</figcaption>
                  </figure>
                  <p>
                    {{ feed.description }}
                  </p>
                  <div class="bl_card_psWrapper">
                    <i class="bl_card_ps __chat">{{ feed.commentCount }}</i>
                    <i class="bl_card_ps __heart">{{ feed.likeCount }}</i>
                  </div>
                </div>
              </NuxtLink>
            </div>
            <!--왼쪽 버튼은 .blind로 조절 -->
            <button
              v-show="feedCarouselPrevButtonShown"
              class="--left"
              @click="addFeedCarouselIndex(-3)"
            ></button>
            <button
              v-show="feedCarouselNextButtonShown"
              class="--right"
              @click="addFeedCarouselIndex(+3)"
            ></button>
          </div>
          <NuxtLink
            :to="`/gathering/feed/list`"
            class="bl_article_btn_mobile el_lineBtn __m __arrow hp_mt24"
            >모두보기</NuxtLink
          >
        </div>
      </div>
    </section>
    <!-- 자주 묻는 질문 -->
    <section class="bl_article">
      <div class="bl_article_header">
        <h2>자주 묻는 질문</h2>
        <NuxtLink
          to="/customerService"
          class="bl_article_btn el_plainBtn_s __arrow __fontLarge"
          >고객센터</NuxtLink
        >
      </div>
      <ul class="bl_cardList __csV">
        <li class="bl_card">
          <h2
            :class="qnas[0].opened && '--open_onMobile'"
            @click.stop="qnas[0].opened = !qnas[0].opened"
          >
            오이는 어떤 곳인가요?
          </h2>
          <p>
            <span>
              오이는 사람들이 취미로 자연스럽게 이어질 수 있게 도와주는 커뮤니티
              앱이에요. 같이 운동하고, 취미 공유하고, 정기적으로 모일 수 있는
              소모임이 중심이고요.
            </span>
            <span>
              또 “처음이라 소모임은 부담돼…” 싶은 사람들을 위해 매주 수요일에
              새로운 사람들과 저녁을 함께하는 ‘오이 다이닝’도 있어요. 혼자서
              시작하기 어려운 만남을, 좀 더 편하고 자연스럽게 만들어주는
              곳이라고 보면 돼요.
            </span>
          </p>
        </li>
        <li class="bl_card">
          <h2
            :class="qnas[1].opened && '--open_onMobile'"
            @click.stop="qnas[1].opened = !qnas[1].opened"
          >
            믿을 수 있는 어플인지 궁금해요
          </h2>
          <p>
            <span>
              처음엔 누구나 “이거 괜찮을까?” 싶잖아요. 오이는 대충 만들고 금방
              사라지는 모임보다, 꾸준히 이어지는 모임이 많아지도록 노력했어요.
            </span>
            <span>
              그리고 모임 후에 매너가 좋았던 사람에게 익명으로 ‘매너오이’를
              선물할 수 있어서, 분위기 좋은 문화가 더 잘 유지되는 편이에요.
              문제가 생겼을 때는 앱 안에서 문의/신고로 바로 연락할 수 있게
              운영도 같이 하고 있어요.
            </span>
          </p>
        </li>
        <li class="bl_card">
          <h2
            :class="qnas[2].opened && '--open_onMobile'"
            @click.stop="qnas[2].opened = !qnas[2].opened"
          >
            오이 사용은 무료인가요?
          </h2>
          <p>
            <span>
              오이는 무료로 시작할 수 있어요. 기본적인 모임 탐색과 참여,
              커뮤니티 기능은 누구나 부담 없이 이용할 수 있도록 되어 있습니다.
            </span>
            <span>
              다만 더 적극적으로 활동 범위를 넓히거나 추가 기능이 필요한
              경우에는 일부 유료 옵션이 제공되고 있어요.
            </span>
          </p>
        </li>
      </ul>
      <NuxtLink
        to="/customerService"
        class="bl_article_btn_mobile el_lineBtn __m __arrow hp_mt32"
        >고객센터</NuxtLink
      >
    </section>
    <!-- 채널톡 커스텀 버튼 -->
    <div class="channelTalk_btn_wrapper">
      <a
        target="_blank"
        href="https://pf.kakao.com/_bxfxnHb/chat?bot=true"
        class="channelTalk_btn"
      >
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 31.5C15.6682 31.5 13.3364 30.8864 11.25 29.6591L10.8879 29.478C10.805 29.4366 10.7096 29.4273 10.6202 29.452L5.62872 30.8326C5.3479 30.9103 5.08964 30.6521 5.16732 30.3712L6.54796 25.3797C6.57268 25.2903 6.56341 25.195 6.52193 25.112L6.34091 24.75C5.11364 22.6636 4.5 20.3318 4.5 18C4.5 10.5136 10.5136 4.5 18 4.5C25.4864 4.5 31.5 10.5136 31.5 18C31.5 25.4864 25.4864 31.5 18 31.5Z"
            fill="white"
          />
        </svg>
      </a>
    </div>
    <!-- 푸터 -->
    <footer class="un_homeFooter_bg">
      <div class="un_homeFooter">
        <section class="un_homeFooter_main">
          <div class="un_homeFooter_main_left">
            <div class="un_homeFooter_policyWrapper">
              <a class="un_homeFooter_logo" href="/"></a>
              <div class="un_homeFooter_policyUnit">
                <a
                  class="un_homeFooter_policy"
                  href="./policy/personalInformation.html"
                  >개인정보처리방침</a
                >
                <a class="un_homeFooter_policy" href="./policy/useRule.html"
                  >이용약관</a
                >
              </div>
            </div>
            <ul class="un_homeFooter_info">
              <li>대표 : 마석완</li>
              <li>개인정보책임관리자 : 마석완</li>
              <li>호스팅사업자 : (주)비바라비다</li>
              <li>사업자등록번호 : 628-81-02654</li>
              <li>광주광역시 북구 자미로6번길 45, 509호</li>
            </ul>
          </div>
          <div class="un_homeFooter_main_right">
            <dl class="un_homeFooter_mail">
              <dt>고객 전용 문의</dt>
              <dd>support@oe-app.com</dd>
            </dl>
            <dl class="un_homeFooter_mail">
              <dt>사업 제휴 문의</dt>
              <dd>partnership@oe-app.com</dd>
            </dl>
          </div>
        </section>
        <section class="un_homeFooter_ps">
          <p class="un_homeFooter_copy">© Vivalavida Corp.</p>
          <div class="un_homeFooter_sns">
            <a
              class="--blog"
              target="_blank"
              href="https://blog.naver.com/oi_blog"
            ></a>
            <a
              class="--instargram"
              target="_blank"
              href="https://www.instagram.com/oe_app_official/"
            ></a>
            <a
              class="--facebook"
              target="_blank"
              href="https://www.facebook.com/oi.facebook"
            ></a>
          </div>
        </section>
      </div>
    </footer>
  </section>
</template>

<script setup lang="ts">
import api from "../utils/api";
import { useIndexStore } from "../stores/index";
import { useRandomSeed } from "~/composable/useRandomSeed";
import { useGetStoreLink } from "~/composable/useGetStoreLink";

useHead({
  link: [
    { rel: "canonical", href: "https://oe-app.com" },
    { rel: "stylesheet" },
  ],
  script: [
    {
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@graph": [organizationSchema, softwareAppSchema],
      }),
    },
  ],
});

const downloadModalShown = ref(false);

// 앱 다운로드 버튼 클릭 (PC: QR 모달 오픈 / 모바일: href로 스토어 이동)
const onAppDownloadClick = (isPC: boolean) => {
  marketing.sendNaverConversion("custom001");
  if (isPC) {
    downloadModalShown.value = true;
  }
};

const isMobile = ref(false);
onMounted(() => {
  const mediaQuery = window.matchMedia("(max-width: 1199px)");
  isMobile.value = mediaQuery.matches;
  mediaQuery.addEventListener("change", (e) => {
    isMobile.value = e.matches;
  });
});
const linkTarget = computed(() => (isMobile.value ? "_self" : "_blank"));

const store = useIndexStore();
const {
  gatheringListEnergy,
  gatheringListCommunication,
  gatheringListRanking,
  gatheringFeedList,
} = storeToRefs(store);

const isString = (something: any) => {
  return typeof something === "string";
};

await useAsyncData(async () => {
  const [
    gatheringEnergy,
    gatheringCommunication,
    gatheringRanking,
    gatheringFeed,
  ] = await Promise.all([
    api.getGatheringList(
      ["골프", "등산", "자전거", "레저", "걷기/러닝/마라톤"],
      3,
      0,
      useRandomSeed().value,
    ),
    api.getGatheringList(
      ["여행", "사교/인맥", "노래/보컬", "사진/영상"],
      6,
      0,
      useRandomSeed().value,
    ),
    api.getGatheringList([], 15, 0, useRandomSeed().value, true),
    api.getGatheringFeedList(20, 0),
  ]);
  store.setGatheringListEnergy(gatheringEnergy.list);
  store.setGatheringListCommunication(gatheringCommunication.list);
  store.setGatheringListRanking(gatheringRanking.list);
  store.setGatheringFeedList(gatheringFeed.list);
  return {
    gatheringEnergy,
    gatheringCommunication,
    gatheringRanking,
    gatheringFeed,
  };
});

// 모임랭킹 캐러셀 컨트롤
const rankingCarousel = ref<HTMLElement>(null as any);
const rankingCarouselIndex = ref(0);
const rankingCarouselPrevButtonShown = ref(false);
const rankingCarouselNextButtonShown = ref(true);
const addRankingCarouselIndex = (value: number) => {
  rankingCarouselIndex.value = Math.max(
    0,
    Math.min(
      gatheringListRanking.value.length - 1,
      rankingCarouselIndex.value + value,
    ),
  );
  rankingCarousel.value.style.transition = "transform 0.4s ease-in-out";
  const boxWidth = rankingCarousel.value.getBoundingClientRect().width;
  const width = 400;
  let x = -(rankingCarouselIndex.value * (width + 16));
  const itemTotalLength =
    gatheringListRanking.value.length * 400 +
    (gatheringListRanking.value.length - 1) * 16;
  const emptySpace = itemTotalLength - boxWidth;
  x = Math.max(x, -emptySpace);
  rankingCarousel.value.style.transform = `translateX(${x}px)`;
  rankingCarouselPrevButtonShown.value = x < 0;
  rankingCarouselNextButtonShown.value = x > -emptySpace;
};

/////////////////////////////////////////////////////////////////////

// 피드 캐러셀 컨트롤
const feedCarousel = ref<HTMLElement>(null as any);
const feedCrarouselIndex = ref(0);
const feedCarouselPrevButtonShown = ref(false);
const feedCarouselNextButtonShown = ref(true);
const addFeedCarouselIndex = (value: number) => {
  feedCrarouselIndex.value = Math.max(
    0,
    Math.min(
      gatheringFeedList.value.length - 1,
      feedCrarouselIndex.value + value,
    ),
  );
  feedCarousel.value.style.transition = "transform 0.4s ease-in-out";
  const boxWidth = feedCarousel.value.getBoundingClientRect().width;
  const width = 320;
  let x = -(feedCrarouselIndex.value * (width + 16));
  const itemTotalLength =
    gatheringFeedList.value.length * 320 +
    (gatheringFeedList.value.length - 1) * 16;
  const emptySpace = itemTotalLength - boxWidth;
  x = Math.max(x, -emptySpace);
  feedCarousel.value.style.transform = `translateX(${x}px)`;
  feedCarouselPrevButtonShown.value = x < 0;
  feedCarouselNextButtonShown.value = x > -emptySpace;
};
//////////////////////////////////////////

const qnas = ref([{ opened: false }, { opened: false }, { opened: false }]);
</script>

<style>
@import "@/assets/css/home.css";
@import "@/assets/css/home_base.css";
</style>
